import { EWAYBILL_RECHARGE_CUSTOMER_REQUEST, CREATE_EWAYBILL_RECHARGE, GET_EWAYBILL_RECHARGE_CUSTOMERS, EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE, GET_EWAYBILL_RECHARGE_CUSTOMER_DETAIL } from '../types';

const initialState = {
  customers: [],
  customerDetail: [],
  loading: false,
  error: null,
};

const ewayBillRechargeReducer = (state = initialState, action) => {
  switch (action.type) {
    case EWAYBILL_RECHARGE_CUSTOMER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_EWAYBILL_RECHARGE_CUSTOMERS: {
      return {
        ...state,
        customers: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_EWAYBILL_RECHARGE_CUSTOMER_DETAIL: {
      return {
        ...state,
        customerDetail: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_EWAYBILL_RECHARGE:
      return {
        ...state,
        customers: [action.payload, ...state.customers],
        loading: false,
        error: null
      };
    case EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default ewayBillRechargeReducer;
